import { BsPlayCircle, BsImage } from 'react-icons/bs';

interface TipoBancaConfig {
    temBotaoAusente: boolean;
    temBotaoMidia: boolean;
    labelMidia?: string;
    iconeMidia?: React.ComponentType;
    endpointMidia?: (bancaId: string, candidatoId: string) => string;
    tipoMidia?: 'video' | 'image';
    requerConfirmacaoInicio: boolean;
}

export const TIPO_BANCA_CONFIG: Record<string, TipoBancaConfig> = {
    Facial: {
        temBotaoAusente: true,
        temBotaoMidia: true,
        labelMidia: 'Foto',
        iconeMidia: BsImage,
        endpointMidia: (bancaId: string, candidatoId: string) => 
            `/bancas/${bancaId}/candidatos/${candidatoId}/fotoUrl`,
        tipoMidia: 'image',
        requerConfirmacaoInicio: false
    },
    Virtual: {
        temBotaoAusente: true,
        temBotaoMidia: false,
        requerConfirmacaoInicio: true
    },
    Recursal: {
        temBotaoAusente: false,
        temBotaoMidia: true,
        labelMidia: 'Vídeo',
        iconeMidia: BsPlayCircle,
        endpointMidia: (bancaId: string, candidatoId: string) => 
            `/bancas/${bancaId}/candidatos/${candidatoId}/videoUrl`,
        tipoMidia: 'video',
        requerConfirmacaoInicio: false
    }
};

export const getConfigBanca = (tipo: string): TipoBancaConfig => {
    return TIPO_BANCA_CONFIG[tipo] || {
        temBotaoAusente: true,
        temBotaoMidia: false,
        requerConfirmacaoInicio: false
    };
};
